import { Component, OnInit } from '@angular/core';
import { JobService } from 'src/app/services/job.service';
import { CollectService } from 'src/app/services/collect.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ApplyService } from 'src/app/services/apply.service';
import { JobStatus } from 'src/app/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-agent-job-list',
  templateUrl: './job-list.component.html',
  styleUrls: ['./job-list.component.scss']
})
export class JobListComponent implements OnInit {
  constructor(private jobService: JobService, private collectService: CollectService, private spinner: SpinnerService,
    private applyService: ApplyService) { }
  get archived() { return this._archived; }
  set archived(val: boolean) { this._archived = val; this.load(); }
  JobStatus = JobStatus;

  imageUrl = environment.app.filesUrl;

  limit = 10;
  clicks: any = {};
  applies: any = {};
  jobs: any[];
  total: number;
  _archived = false;

  async ngOnInit() { await this.load(); }

  async load(page: { from: number, limit: number } = { from: 0, limit: this.limit }) {
    this.spinner.show();
    const result = await this.jobService.agentList(this.archived ? JobStatus.Archived : null, page.from, page.limit);
    this.jobs = result.jobs;
    this.total = result.total;
    this.clicks = (await this.collectService.getJobClicks(this.jobs.map(_ => _.Id))) || {};
    this.applies = (await this.applyService.getJobApplies(result.jobs.map(_ => _.Id))) || {};
    this.spinner.hide();
  }



  async pay(job: any) {
    this.spinner.show();
    await this.jobService.pay(job.Id);
  }

  async pause(job: any, i: number) {
    this.spinner.show();
    job = Object.assign(job, await this.jobService.setStatus(job.Id, JobStatus.Paused));
    this.spinner.hide();
  }

  async start(job: any, i: number) {
    this.spinner.show();
    job = Object.assign(job, await this.jobService.setStatus(job.Id, JobStatus.Started));
    this.spinner.hide();
  }

  async archive(job: any, i: number) {
    this.spinner.show();
    job = Object.assign(job, await this.jobService.setStatus(job.Id, JobStatus.Archived));
    this.spinner.hide();
  }
  async unArchive(job: any, i: number) {
    this.spinner.show();
    job = Object.assign(job, await this.jobService.setStatus(job.Id, job.IsPaid ? JobStatus.Pending : JobStatus.NotPaid));
    this.spinner.hide();
  }
}
